export default {
  Problem_feedback: '请输入问题和建议',
  contact_information: '请输入联系方式',
  contact_information_the: '联系方式请输入',
  import: '输入',
  Please_enter: '请输入',
  Old_password: '旧密码',
  New_password: '新密码',
  Required: '必填',
  Enteranewpassword: '输入新密码',
  Confirm_new_password: '确认新密码',
  mobile: '手机号',
  QQ: 'QQ号',
  postbox: '邮箱',
  contact_you: '方便联系到您',
  question: '请输入您的问题',
  Characters_up: '6-16个字符',
  address: '请输入详细地址',
  renewal_contact: '请输入续费联系方式',
  ple_contact_name: '请输入联系人姓名',
  Please_enter_withdrawal: '请输入收回',
  Number_of_cards: '的数量',
  Pleasechooseanagent: '请选择代理商',
  Pleaseenterthequantity: '请输入数量',
  Pleaseentertheuserprefixnickname: '请输入用户前缀昵称（2-7位）',
  PleaseEnterImei: '请输入15位IMEI号码',
  Remarkswithin: '备注：100字以内',
  Pleaseselectaunit: '请选择单位',
  Pleaseselectagrouptojoin: '请选择要加入的群组',
  Pleaseentertheunitname: '请输入单位名称',
  companynamerequired: '（必填：4-20文字、字母、数字）',
  Pleaseenterloginaccount: '请输入登录账户',
  loginaccountrequired: '（必填：6-20位字母、数字）',
  Pleaseenteryourpassword: '请输入登录密码',
  loginpasswordrequired: '（必填：6-16字母、数字）',
  Pleaseenteracontactname: '请输入联系人姓名',
  contactnamerequired: '（必填：2-10文字、字母、数字）',
  Pleaseenteraprefixname: '请输入前缀名称',
  prefixnamerequired: '(必填：2-12文字、字母、数字)',
  Contactnamerequired: '联系人姓名（必填：2-10个字符）',
  mobilephonenumber: '手机号码（可选）',
  Enteremailaddress: '输入邮箱地址（可选）',
  Enterdetailedaddress: '输入详细地址（可选）',
  Pleaseenteragroupname: '请输入群组名称（必填：2-15字符）',
  Groupnamerequired: '群组名称（必填：2-15个字符）',
  Pleasetypeyourphonenumber: '请输入联系电话',
  Pleaseinputtheemailaddress: '请输入邮箱地址',
  Pleaseenterthemailingaddress: '请输入通讯地址',
  RequiredPleaseenterusernickname: '（必填）请输入用户昵称',
  Pleasemobilephonenumber: '（可选）请输入11位手机号码',
  PleaseentertheoriginalIMEInumber: '请输入15位IMEI原始号码',
  PleaseenterthenewIMEInumber: '请输入15位IMEI新号码',
  Pleaseenteraverificationcode: '请输入4位验证码',
  Pleaseenterthemobilephonenumbertobebound: '请输入要绑定的手机号码',
  PleaseenteragroupnameTow: '请输入群组名',
  Pleaseenterusername: '请输入用户名',
  Fencenamerequired: '围栏名称（必填：1-15个字符）',
  Pleaseenterthefencename: '请输入围栏名称',
  Pleaseselectatime: '请选择时间',

  please_rest_password: '您好,为了您的账号安全,建议先重置登录密码',
  TheLastGroupUnderTheUnitCannotBeDeleted: '单位下最后一个群组不可以删除',
}
